<div class="flex flex-column gap-2 history-container">
    @for (historyGroup of store.groupedHistory(); track historyGroup.key) {
        <div class="w-full pr-3">
            @if (historyGroup.routes.length === 1) {
                @let route = historyGroup.routes[0];
                <app-button styleClass="w-full history-entry" severity="secondary"
                    (clickEvent)="navigate(route.url)">
                    <div class="text-left flex align-items-center">
                        @for (name of route.fullPath; track $index; let i = $index) {
                            @if (i > 0) {
                                <i class="pi pi-angle-right"></i>
                            }
                            <span>{{ name }}</span>
                        }
                    </div>
                </app-button>
            } @else {
                <p-accordion styleClass="history-accordion" [value]="-1">
                    <p-accordion-panel [value]="0">
                        <p-accordion-header>
                            <div class="flex flex-1 gap align-items-center justify-content-between mr-2">
                                <span>{{ historyGroup.group }}</span>
                                <p-badge [value]="historyGroup.routes.length"/>
                            </div>
                        </p-accordion-header>
                        <p-accordion-content>
                            <div class="flex flex-column gap-2 pt-2 pl-3">
                                @for (route of historyGroup.routes; track route.key) {
                                    <app-button
                                        styleClass="w-full history-entry"
                                        severity="secondary"
                                        (clickEvent)="navigate(route.url)"
                                    >
                                        <div class="text-left flex align-items-center">
                                            @for (name of route.path; track $index; let i = $index) {
                                                @if (i > 0) {
                                                    <i class="pi pi-angle-right"></i>
                                                }
                                                <span>{{ name }}</span>
                                            }
                                        </div>
                                    </app-button>
                                }
                            </div>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            }
        </div>
    }
</div>
